import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { SingleDropdownComponent } from 'app/shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';
import { BehaviorSubject } from 'rxjs';
import { CountryDto } from '@splitsecondconnect/ultramarine-shared';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { IDENTITY_DOCUMENT_TYPES } from '../../../translations/customers-select-items';
import { DriverFlatModel } from '../../../../../../shared/models/driver-flat.model';
import { SettingsService } from '../../../../settings/services/settings.service';
import { DatetimePickerComponent } from '../../../../../../shared/components/datetime-picker/datetime-picker.component';
import { toDateString } from '../../../../../../shared/functions/sectionCasters.function';
import { MoreSectionsComponent } from 'app/shared/components/more-sections/more-sections.component';

@Component({
	selector: 'app-customers-driver',
	templateUrl: 'customers-driver.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SingleDropdownComponent,
		DatetimePickerComponent,
		SingleDropdownComponent,
		SectionWrapperComponent,
		MoreSectionsComponent,
	],
})
export class CustomersDriverComponent
	extends BaseSectionComponent<DriverFlatModel>
	implements OnInit
{
	countries = inject(SettingsService).countriesSelectItems;
	protected _skipCount: number = 0;
	public countries$: BehaviorSubject<CountryDto[]> = new BehaviorSubject<
		CountryDto[]
	>(null);

	public customerIdentityDocumentTypes = IDENTITY_DOCUMENT_TYPES;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			identityDocumentType: [null],
			identityDocumentNumber: [null],
			identityDocumentIssueDate: [null],
			identityDocumentExpiryDate: [null],
			identityDocumentIssuedByCountryId: [null],
			drivingLicenseNumber: [null],
			drivingLicenseCategory: [null],
			drivingLicenseIssueDate: [null],
			drivingLicenseExpiryDate: [null],
			drivingLicenseIssuedByCountryId: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			identityDocumentType: this.recordData().driverIdentityDocumentType,
			identityDocumentNumber: this.recordData().driverIdentityDocumentNumber,
			identityDocumentIssueDate: toDateString(
				this.recordData().driverIdentityDocumentIssueDate,
			),
			identityDocumentExpiryDate: toDateString(
				this.recordData().driverIdentityDocumentExpiryDate,
			),
			identityDocumentIssuedByCountryId:
				this.recordData().driverIdentityDocumentIssuedByCountryId,
			drivingLicenseNumber: this.recordData().driverDrivingLicenseNumber,
			drivingLicenseCategory: this.recordData().driverDrivingLicenseCategory,
			drivingLicenseIssueDate: toDateString(
				this.recordData().driverDrivingLicenseIssueDate,
			),
			drivingLicenseExpiryDate: toDateString(
				this.recordData().driverDrivingLicenseExpiryDate,
			),
			drivingLicenseIssuedByCountryId:
				this.recordData().driverDrivingLicenseIssuedByCountryId,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<DriverFlatModel> {
		return {
			driverIdentityDocumentType:
				this.detailsForm.controls.identityDocumentType.value,
			driverIdentityDocumentNumber:
				this.detailsForm.controls.identityDocumentNumber.value,
			driverIdentityDocumentIssueDate:
				this.detailsForm.controls.identityDocumentIssueDate.value,
			driverIdentityDocumentExpiryDate:
				this.detailsForm.controls.identityDocumentExpiryDate.value,
			driverIdentityDocumentIssuedByCountryId:
				this.detailsForm.controls.identityDocumentIssuedByCountryId.value,
			driverDrivingLicenseNumber:
				this.detailsForm.controls.drivingLicenseNumber.value,
			driverDrivingLicenseCategory:
				this.detailsForm.controls.drivingLicenseCategory.value,
			driverDrivingLicenseIssueDate:
				this.detailsForm.controls.drivingLicenseIssueDate.value,
			driverDrivingLicenseExpiryDate:
				this.detailsForm.controls.drivingLicenseExpiryDate.value,
			driverDrivingLicenseIssuedByCountryId:
				this.detailsForm.controls.drivingLicenseIssuedByCountryId.value,
		};
	}
}
